import { Box, Button, Grid, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { HeaderFiltro } from "../header-filtro";
import { PreviaFiltroLocalizacao } from "./previa-filtro-localizacao";
import { LocalizacaoDialog } from "./LocalizacaoDialog";
import { GeolocalizacaoDialog } from "./GeolocalizacaoDialog";
import { useGeolocalizacaoService, useLocalizacaoService } from "../../../../../../../use-cases/geo-veles";
import { PreviaFiltroGeolocalizacao } from "./previa-filtro-geolocalizacao";
import { useEffect } from "react";

export const FiltroLocalizacao = () => {
  // State
  const { projetos, localizacao, geolocalizacao } = useAppSelector((state) => state)
  // Hook
  const { openLocalizacaoDialog } = useLocalizacaoService()
  const { openGeolocalizacaoDialog } = useGeolocalizacaoService()

  useEffect(() => {
    if (!projetos.filtrosSelecionados?.localizacao) {
      
      
    }})

  return (
    <>
      <HeaderFiltro titulo="Localização / Geolocalização"
        descricao={<>
          <Typography>
            É a busca de pessoas através de endereços. Nesta opção é possível localizar a pessoa no atual endereço em que reside.
          </Typography>
          <Typography>
            Essa busca pode ser feita por localização em diferentes níveis, desde Macrorregião (Norte / Nordeste) ao CEP.
          </Typography>
          <Typography
            style={{
              marginBottom: '10px'
            }}
          >
            Ou buscando por Geolocalização, indicando um ponto central no mapa e um raio de distância.
          </Typography>
          <Typography>
            Caso esta opção não seja selecionada, a busca será feita no Brasil inteiro.
          </Typography>
        </>}
      />
      <Box my={3} mt={5}>
        <Grid container spacing={2}>
          <Grid item
            xs={
              (
                (projetos.filtrosSelecionados?.localizacao?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeLocalizacao?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.listasCEP?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeListasCEP?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.listasCidades?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeListasCidades?.length ?? 0) > 0
              ) ? 12 : 6
            }
            display={projetos.filtrosSelecionados?.geolocalizacao ? 'none' : 'inherit'}
          >
            <Button
              fullWidth
              onClick={() => {
                openLocalizacaoDialog(true)
              }}
              endIcon={<AddIcon />}
            >
              <Typography variant="body1" fontWeight="bold">
                Filtrar por localização
              </Typography>
            </Button>
          </Grid>
          <Grid item
            xs={projetos.filtrosSelecionados?.geolocalizacao ? 12 : 6}
            display={
              (
                (projetos.filtrosSelecionados?.localizacao?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeLocalizacao?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.listasCEP?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeListasCEP?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.listasCidades?.length ?? 0) > 0 ||
                (projetos.filtrosSelecionados?.purgeListasCidades?.length ?? 0) > 0
              ) ? 'none' : 'inherit'
            }
          >
            <Button              
              fullWidth
              onClick={() => {
                openGeolocalizacaoDialog(true)
              }}
              endIcon={<AddIcon />}
            >
              <Typography variant="body1" fontWeight="bold">
                Filtrar por Geolocalização
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12}>
            <PreviaFiltroLocalizacao />
          </Grid>
          <Grid item xs={12}>
            <PreviaFiltroGeolocalizacao />
          </Grid>
        </Grid>
      </Box >

      {
        localizacao.openLocalizacaoDialog ?
          <LocalizacaoDialog />
          : geolocalizacao.openDialog ?
            <GeolocalizacaoDialog />
            : null
      }
    </>
  )
}